import { Form } from 'react-final-form';
import { GreenlightRegistrationLookupFields } from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightRegistrationLookupFields';
import { KeyInfoShowMore } from 'components/CarValuationPage/components/KeyInfoShowMore/KeyInfoShowMore';
import { SectionBreakHeader } from 'components/HubPages/components/SectionBreakHeader/SectionBreakHeader';
import type {
  FormValues,
  GreenlightRegistrationLookupProps,
} from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightRegistrationLookup.typed';
import * as Styled from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightRegistrationLookup.styled';
import { HistoryCheckItems } from 'components/HubPages/components/GreenlightHistoryCheck/HistoryCheckItems/HistoryCheckItems';
import { Loading } from 'components/Toolkit/Loading/Loading';
import { CDN_STATIC_ASSETS } from 'utils';
import { GreenlightPurchaseFooter } from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightPurchaseFooter/GreenlightPurchaseFooter';
import { useGreenlightRegistrationLookup } from 'components/HubPages/components/GreenlightHistoryCheck/GreenlightRegistrationLookup.hook';
import { useMapVehicleDataToKeyInfo } from 'components/HubPages/components/GreenlightHistoryCheck/MapVehicleDataToKeyInfo.hook';

function GreenlightRegistrationLookup({
  ctaText,
  titleImage,
  heroTitle,
  historyCheckItemsTitle,
  historyCheckItems,
}: GreenlightRegistrationLookupProps) {
  const { registrationLookup, vehicleData } = useGreenlightRegistrationLookup();
  const { vehicleMetaTitle, vehicleMetaList, currentReport, keyInfoListItems } =
    useMapVehicleDataToKeyInfo(vehicleData);

  const onSubmit = (values: FormValues) => {
    registrationLookup(values.registration);
  };

  return (
    <>
      <Styled.LookupWrapper>
        <Styled.TextWrapper>
          <Styled.Text>{heroTitle}</Styled.Text>
          {titleImage && (
            <Styled.TitleImg
              alt="Greenlight History Check"
              src={titleImage?.url}
            />
          )}
        </Styled.TextWrapper>
        <Styled.FormWrapper>
          <Form
            onSubmit={onSubmit}
            render={({ handleSubmit, form: { getState } }) => {
              const {
                invalid,
                submitting,
                modifiedSinceLastSubmit,
                submitSucceeded,
              } = getState();
              return (
                <form onSubmit={handleSubmit} noValidate>
                  <Styled.RegistrationLookupContainer>
                    <Styled.RegistrationLookupContent>
                      <GreenlightRegistrationLookupFields />
                      <Styled.Button
                        type="submit"
                        data-testid="registration-lookup-submit"
                        disabled={
                          invalid ||
                          (submitSucceeded && !modifiedSinceLastSubmit)
                        }
                      >
                        {submitting ? (
                          <Loading
                            size="DEFAULT"
                            cdnUrl={CDN_STATIC_ASSETS}
                            color={'LIGHT'}
                          />
                        ) : (
                          ctaText
                        )}
                      </Styled.Button>
                    </Styled.RegistrationLookupContent>
                  </Styled.RegistrationLookupContainer>
                </form>
              );
            }}
          />
        </Styled.FormWrapper>
      </Styled.LookupWrapper>

      {vehicleData ? (
        <Styled.SectionWrapper>
          <SectionBreakHeader title="Your Vehicle Details" />
          <KeyInfoShowMore
            infoList={vehicleMetaList}
            keyInfoTitle={vehicleMetaTitle}
            keyInfoListItems={keyInfoListItems}
          />
        </Styled.SectionWrapper>
      ) : (
        <Styled.SectionWrapper data-testid={'history-check-items'}>
          <HistoryCheckItems
            items={historyCheckItems}
            title={historyCheckItemsTitle?.text}
          />
        </Styled.SectionWrapper>
      )}
      {currentReport && (
        <GreenlightPurchaseFooter
          currentReport={currentReport}
          reportText={'Get full report for '}
          registration={vehicleData?.registration || ''}
        />
      )}
    </>
  );
}

export { GreenlightRegistrationLookup };
